const InfoItem = ({ icon, title, subtitle, content, textColor = '', showSubtitleOn = 'md', additionalClass = '' }) => (
    <div className={`w-full flex items-center ${textColor} ${additionalClass}`}>
        <div className="w-[24px] flex items-center justify-center">
            {icon}
        </div>
        <div className="w-[calc(100%-24px)] flex flex-col justify-center truncate">
            {title && <div className="text-xs font-bold">{title}</div>}
            {subtitle && (
                <div className={`text-[10px] hidden ${showSubtitleOn}:flex`}>{subtitle}</div>
            )}
            {content && (
                <div className={`text-[9px] ${showSubtitleOn}:text-base truncate`}>
                    {content}
                </div>
            )}
        </div>
    </div>
);

export default InfoItem;